import React, { useCallback, useState } from 'react'
import useConfigureAndSendTag from '../../analytics/useConfigureAndSendTag'
import { useSelector } from 'react-redux'
import { searchAddress } from '../../../store/address/address.actions'
import { selectHomeWorkOrFakeFavorites } from '../../../store/suggest/suggest.selectors'
import { removeHtmlEmTags } from '../../../utils/string'
import T from '../../i18n/T'
import { withFrenchSite } from '../../i18n/i18nSite'
import SuggestContentList from '../../suggest/SuggestContentList'
import useIncentiveClick from '../../suggest/useIncentiveClick'
import { useAction } from '../../utils/react-redux'
import s from './FavoritesPush.less'
import useFavoritePushTagBuilder from './useFavoriteClickHandler'

const FavoritesPushHp = () => {
  const homeWorkFavorites = useSelector(selectHomeWorkOrFakeFavorites)
  const [selectedId, setSelectedId] = useState(null)

  const updateSelectedId = idx => {
    setSelectedId(idx)
  }

  const execSearchAddress = useAction(searchAddress)
  const configureAndSendTag = useConfigureAndSendTag()

  const { favoritePushTabBuilder } = useFavoritePushTagBuilder()

  const onClick = useCallback(
    suggest => {
      configureAndSendTag(favoritePushTabBuilder(suggest))

      const { labels, address } = suggest
      const label = removeHtmlEmTags(address || labels.join(' '))
      execSearchAddress({ terms: label })
    },
    [favoritePushTabBuilder]
  )

  const { onIncentiveClick } = useIncentiveClick({ onClick, incentiveTagClickBuilder: favoritePushTabBuilder })

  return (
    <div className={s.FavoritesPushHp}>
      <div className={s.FavoritesPushTitle}>
        <span>
          <T id={'suggest.favorites.my-favorites'} />
        </span>
      </div>
      <SuggestContentList
        suggestions={homeWorkFavorites}
        onClick={onIncentiveClick}
        selectedId={selectedId}
        updateSelectedId={updateSelectedId}
      />
    </div>
  )
}
export default withFrenchSite(FavoritesPushHp)
